import React from 'react';
import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Title from './Title';


function preventDefault(event) {
  event.preventDefault();
}

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
}));

export default function Orders({rows}) {
  const classes = useStyles();
  return (
    <React.Fragment>
      <Title>Ordenes Pendientes por Asignar</Title>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Nro. Orden</TableCell>
            <TableCell>Restaurante</TableCell>
            <TableCell>Destino</TableCell>
            <TableCell>Hora</TableCell>
            <TableCell>Fecha y hora Programada</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id}>
              <TableCell>{row.order_number}</TableCell>
              <TableCell>{row.fantasy_name}</TableCell>
              <TableCell>{row.address_line_1}</TableCell>
              <TableCell>{row.delivery_program_hour}</TableCell>
              <TableCell>{row.program_datetime}</TableCell>
            </TableRow>
          ))}

          {
            rows.length===0 ?
            <TableRow>
              <TableCell>No hay ordenes pendientes</TableCell>
            </TableRow>
            :
            null
          }
        </TableBody>
      </Table>
      <div className={classes.seeMore}>
        <Link color="primary" target="_blank" href="https://api.max.delivery/view-map/5bfc7ff94c94bb95a31e7b9fdcf6d31861df5b4932cb4b41a59de070d">
          Ver todas
        </Link>
      </div>
    </React.Fragment>
  );
}
